import { render, staticRenderFns } from "./ApplicationUpdateList.vue?vue&type=template&id=fe98c7be&"
import script from "./ApplicationUpdateList.vue?vue&type=script&lang=js&"
export * from "./ApplicationUpdateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports